<script>
export default {
  props: {
    statistics: {
      type: Array,
      default: () => []
    },
    type: {
      required: true,
      type: String
    }
  }
}
</script>
<template>
  <div class="card rounded">
    <table class="table">
      <thead>
        <tr>
          <th scope="col" class="text-center">Ranking</th>
          <th scope="col" class="text-center">Total {{ type }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in statistics" :key="index">
          <th scope="row" class="d-flex align-items-center">
            <span>{{ index+1 }}</span>
            <b-img v-if="Object.values(row)[3]" :src="Object.values(row)[3]" height="30" width="50" rounded="circle" class="px-2" />
            <b-img v-else :src="require('@/assets/images/users/operator.png')" height="30" rounded="circle" class="px-2" />
            <span>{{ Object.values(row)[2] }}</span>
          </th>
          <td class="font-weight-bold text-center">
            <span v-if="type == 'Deal'">Rp {{ Object.values(row)[1] | convertToRupiah }}</span>
            <span v-else>{{ Object.values(row)[1] }}</span>
          </td>
        </tr>
        <tr v-if="statistics.length == 0">
          <th colspan="2" class="font-weight-bold text-center">
            Belum Ada Data 
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>